export const getMembershipSubscriptionItem = (membershipItems) => {
  if (!membershipItems || !membershipItems.length) {
    return;
  }

  return membershipItems.find(
    (val) => val.metadata.type === "EVENT_MEMBERSHIP"
  );
};

export const getSingleTicketItem = (membershipItems) => {
  if (!membershipItems || !membershipItems.length) {
    return;
  }

  return membershipItems.find((val) => val.metadata.code === "SINGLE_EVENT");
};
